import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.DownloadLegacyPdf.IRequest;
type Headers = Api.Core.Contract.DownloadLegacyPdf.IHeaders;
type ResponseString = Api.Core.Contract.DownloadLegacyPdf.IResponseString;
const downloadLegacyPdfUrl = '/api/Sales/Contract/DownloadLegacyPdf/:legacyId';
export async function downloadLegacyPdfBase64(params?: Request): Promise<Api.Res<ResponseString>> {
  const serverResponse = await executeServerApi<Request, ResponseString, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(`${downloadLegacyPdfUrl}`, params),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
